import styled from "styled-components";
import { Modal } from "components/Modal";

export const UnsubscribeStrategyModalContainer = styled(Modal)`
  text-align: center;

  .modal-content {
    padding: 0px;
    padding-bottom: 18px;

    .modal-body {
      margin-top: 0px;
      padding: 0px;
    }
  }

  .body-content {
    padding: 10px;

    .description {
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      line-height: normal;
      margin-top: 20px;
    }
  }

  .heading {
    display: flex;
    align-items: center;
    padding: 14px 15px;
    background-color: ${({ theme }) => theme.modal.bg.secondary};

    h2 {
      width: 100%;
      text-align: center;
      color: ${({ theme }) => theme.card.font.tertiary};
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 0px;
    }
  }

  .description {
    font-weight: 500;
    font-size: 15px;
    color: ${({ theme }) => theme.global.extraInfo.font.color};
  }

  .reasons {
    text-align: left;
    margin: 20px 30px 30px;

    label {
      font-weight: 400;
      font-size: 13px;
      color: ${({ theme }) => theme.global.extraInfo.font.color};
    }

    .radio-wrap {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      input[type="radio"] {
        margin-right: 5px;
        appearance: none;
        border: 1px solid #e7e3fc;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        position: relative;
        cursor: pointer;
      }

      input[type="radio"]:before {
        content: "";
        display: inline-block;
        width: 15px;
        height: 15px;
        background-color: #e7e3fc;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      input[type="radio"]:checked:before {
        opacity: 1;
        background-color: #0d6efd;
      }
    }
  }

  .details {
    font-weight: 500;
    font-size: 12px;
    color: #838383;
  }

  .button-wrapper {
    .btn-yes {
      width: calc(100% - 60px);
      background: #ff3f3f;
      padding: 10px 0;
      font-weight: 500;
      font-size: 14px;
      height: 40px;
      border: medium;
      margin: 10px 30px;
    }
  }
`;
